<template>
  <v-container>
    <div class="tooltip" ref="tooltip" v-show="visibleTooltip">
      {{ tooltipCity.name }} <br />
      {{ schoolsByCity(tooltipCity.id).length }} Escolas
    </div>
    <v-row>
      <svg viewBox="0 0 198.4252 226.7717">
        <g>
          <path
            v-for="path in paths"
            :key="path.id"
            :id="path.id"
            :d="path.d"
            @mousemove="showTooltip(path.id, $event)"
            @mouseout="visibleTooltip = false"
            @click="selectCity(path.id)"
          />
        </g>
      </svg>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { cities } from "@/utils";
import { paths } from "./pathsData";

export default {
  name: "amapaMap",
  data() {
    return {
      paths,
      visibleTooltip: false,
      tooltipCity: {
        name: "",
        id: "",
      },
      selectedCity: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    ...mapGetters(["schoolsByCity"]),
  },
  methods: {
    showTooltip(id, mouse) {
      this.visibleTooltip = true;
      if (this.tooltipCity.id != id) {
        this.tooltipCity = cities.find((obj) => obj.id == id);
      }
    },
    selectCity(id) {
      cities.forEach((element) => {
        document.getElementById(element.id).style.fill = "#7d96b5";
      });
      document.getElementById(id).style.fill = "#394a61";
      this.selectedCity = cities.find((obj) => obj.id == id);
      this.$emit("city", this.selectedCity);
    },
    clearCity() {
      document.getElementById(this.selectedCity.id).style.fill = "#7d96b5";
      this.selectedCity = { name: "", id: "" };
      this.$emit("city", {});
    },
  },
};
</script>

<style scoped>
.tooltip {
  border: 1px solid black;
  padding: 5px;
  background-color: white;
  position: absolute;
  z-index: 999;
}

path {
  fill: #7d96b5;
  cursor: pointer;
  stroke: white;
  stroke-width: 0.1;
}

path:hover {
  opacity: 0.8;
}
</style>